import React from 'react';
//import ClipLoader from 'react-spinners/ClipLoader';
import './styles/Loading.css'; // Import the CSS file for styling

const Loading = ({ text = "Cargando tabla...", gifPath = "/ducking.gif" }) => {
    return (
        <div className="min-w-460 m-t-10">
            <div className="row align-items-center">
                <div className="col-2 offset-5">
                    <img
                        src={gifPath} 
                        alt="Loading"
                        className="loading-gif"
                    />
                </div>
            </div>
            <div className="row col-12">
                <span className="loading-text">{text}</span>
            </div>

        </div>
    );
};

export default Loading;